import {
  AccountLockupFragment,
  ChainBadgeFragment,
  CollectionLockupFragment,
  CurrencyLockupFragment,
} from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { CollectionDropStatusChipFragment } from "@/components/collection/CollectionMetadataChips/chips/CollectionDropStatusChip"
import { AccountEnforcementBadgeFragment } from "@/components/trustandsafety/AccountEnforcementBadge.fragment"
import { profileUrlFragment } from "../account/utils"
import { NewCollectionChipFragment } from "../collection/NewCollectionChip"
import { collectionUrlFragment } from "../collection/utils"
import { CurrencyLinkFragment } from "../currencies/CurrencyLink.fragment"
import { CurrencyPriceFragment } from "../currencies/CurrencyPrice/CurrencyPrice.fragment"
import { CurrencySparkLineChartFragment } from "../currencies/charts/CurrencySparkLineChart/CurrencySparkLineChart.fragment"
import { currencyUrlFragment } from "../currencies/urls"
import { currencyIdentifierFragment } from "../currencies/utils"
import { ItemAvatarFragment } from "../items/avatar/ItemAvatar"
import { CollectionLinkFragment } from "../items/collection/CollectionLink.fragment"
import { ItemPreviewTooltipFragment } from "../items/ItemPreviewTooltip/ItemPreviewTooltip.fragment"
import { itemUrlFragment } from "../items/utils"
import { TokenPriceFragment } from "../price/TokenPrice.fragment"

export const ExpandedSearch_currencyFragment = graphql(
  `
    fragment ExpandedSearchCurrency on Currency {
      id
      contractAddress
      symbol
      name
      stats {
        oneDay {
          priceChange
        }
      }
      chain {
        identifier
        ...ChainBadge
      }
      ...currencyIdentifier
      ...CurrencyLockup
      ...CurrencyPrice
      ...CurrencySparkLineChart
      ...CurrencyLink
      ...currencyUrl
    }
  `,
  [
    currencyIdentifierFragment,
    ChainBadgeFragment,
    CurrencyLockupFragment,
    CurrencyPriceFragment,
    CurrencySparkLineChartFragment,
    CurrencyLinkFragment,
    currencyUrlFragment,
  ],
)

export const ExpandedSearch_accountFragment = graphql(
  `
    fragment ExpandedSearchAccount on Profile {
      address
      isVerified
      isCompromised
      ...AccountLockup
      ...AccountEnforcementBadge
      ...profileUrl
    }
  `,
  [AccountLockupFragment, AccountEnforcementBadgeFragment, profileUrlFragment],
)

export const ExpandedSearch_collectionFragment = graphql(
  `
    fragment ExpandedSearchCollection on Collection {
      id
      chain {
        identifier
      }
      ...collectionUrl
      ...CollectionLockup
      ...CollectionLink
      floorPrice {
        pricePerItem {
          ...TokenPrice
        }
      }
      stats {
        totalSupply
        oneDay {
          floorPriceChange
        }
      }
      drop {
        stages {
          startTime
        }
      }
      ...NewCollectionChip
      ...CollectionDropStatusChip
    }
  `,
  [
    collectionUrlFragment,
    CollectionLockupFragment,
    CollectionLinkFragment,
    TokenPriceFragment,
    NewCollectionChipFragment,
    CollectionDropStatusChipFragment,
  ],
)

export const ExpandedSearch_itemFragment = graphql(
  `
    fragment ExpandedSearchItem on Item {
      id
      name
      imageUrl
      ...itemUrl
      ...ItemAvatar
      ...ItemPreviewTooltip
      owner {
        ...AccountLockup
      }
      collection {
        ...CollectionLockup
        chain {
          identifier
        }
      }
    }
  `,
  [
    itemUrlFragment,
    ItemAvatarFragment,
    ItemPreviewTooltipFragment,
    AccountLockupFragment,
    CollectionLockupFragment,
  ],
)
